/*
 * See the file LICENSE for the full license governing this code.
 */

import * as React from 'react';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import { loadStripe } from '@stripe/stripe-js';
import {
  EmbeddedCheckoutProvider,
  EmbeddedCheckout,
} from '@stripe/react-stripe-js';
import { networkWithErrorConvert, useMutation } from '../api';
import Loader from '../components/Loader';
import ErrorMessageWrapper from '../components/ErrorMessageWrapper';

const stripePromise = process.env.REACT_APP_PUBLISHABLE_KEY
  ? loadStripe(process.env.REACT_APP_PUBLISHABLE_KEY)
  : null;

export default function UpgradeUser() {
  const checkoutSessionMutation = useMutation(() =>
    networkWithErrorConvert({
      url: '/v1/create-checkout-session',
      method: 'post',
    })
  );

  React.useEffect(() => {
    if (checkoutSessionMutation.isIdle) {
      checkoutSessionMutation.mutate();
    }
  }, [checkoutSessionMutation]);

  const clientSecret = checkoutSessionMutation.data?.clientSecret;

  return (
    <Box>
      {checkoutSessionMutation.isIdle || checkoutSessionMutation.isLoading ? (
        <Loader />
      ) : clientSecret ? (
        <EmbeddedCheckoutProvider
          stripe={stripePromise}
          options={{ clientSecret }}
        >
          <EmbeddedCheckout />
        </EmbeddedCheckoutProvider>
      ) : (
        <ErrorMessageWrapper
          containerStyles={{
            gap: 2,
            pt: 0,
            justifyContent: 'center',
            alignItems: 'center',
          }}
        >
          <Typography variant="h6">
            {checkoutSessionMutation.error ||
              'Failed to initialize user upgrade'}
          </Typography>
        </ErrorMessageWrapper>
      )}
    </Box>
  );
}
